import EmptyRouterView from 'src/views/Pages/GeneralViews/EmptyRouterView.vue';
import Forecast from 'src/views/Pages/Dashboard/Climate/Report/Forecast.vue';
import ForecastMB from 'src/views/Pages/Dashboard/Climate/Report/ForecastMB.vue';
import Historical from 'src/views/Pages/Dashboard/Climate/Report/Historical.vue';
import StationsData from 'src/views/Pages/Dashboard/Climate/Report/StationsData.vue';
import StationsMap from 'src/views/Pages/Dashboard/Climate/Report/StationsMap.vue';
import Accumulator from 'src/views/Pages/Dashboard/Climate/Accumulator/Index.vue';
import MasterTab from 'src/components/Layouts/MasterTab.vue';

const ClimateRoutes = {
  path: 'climates',
  component: MasterTab,
  props: { reference: 'climateTabs' },
  children: [
    {
      path: 'climateforecast',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'common_words.climate',
          component: Forecast,
          meta: {
            prefix_permission: 'climates_climateforecast',
          },
        },
      ],
    },
    {
      path: 'climateforecastmb',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'common_words.climate',
          component: ForecastMB,
          meta: {
            prefix_permission: 'climates_climateforecastmb',
          },
        },
      ],
    },
    {
      path: 'climatehistorical',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'common_words.climate',
          component: Historical,
          meta: {
            prefix_permission: 'climates_climatehistorical',
          },
        },
      ],
    },
    {
      path: 'climatestationsdata',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'common_words.climate',
          component: StationsData,
          meta: {
            prefix_permission: 'climates_climatestationsdata',
          },
        },
      ],
    },
    {
      path: 'stationsmap',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'common_words.climate',
          component: StationsMap,
          meta: {
            prefix_permission: 'climates_stationsmap',
          },
        },
      ],
    },
    {
      path: 'accumulator',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'common_words.climate',
          component: Accumulator,
          meta: {
            prefix_permission: 'climates_accumulator',
          },
        },
      ],
    },
  ],
};

export default ClimateRoutes;
